export const useAreThankYousSupported = () => {
    const platform = navigator.platform?.toLowerCase() || '';
    const userAgent = navigator.userAgent?.toLowerCase() || '';
    const vendor = navigator.vendor?.toLowerCase() || '';
    const isWindows = /win/.test(platform);
    const isMacOS = /mac/.test(platform);
    const isOpera = /opera|opr\//.test(userAgent);
    const isChrome = !isOpera && /google inc/.test(vendor) && /(?:chrome|crios)\/(\d+)/.test(userAgent);
    const isAACSupported = MediaRecorder.isTypeSupported('video/mp4; codecs="avc1.42E01E, mp4a.40.2"');
    return {
        areThankYousSupported: !(isWindows && isChrome) && !(isMacOS && !isAACSupported),
    };
};
